<template>
  <div class="video-content">
    <div class="majorEvents-title">
      <div style="font-size: 14px;color: #333333">项目简介</div>
      <div style='cursor: pointer;color: #959595;font-size: 12px' @click="moreProject">更多</div>
    </div>
    <div style="height: calc(100% - 25px)">
      <div class="video-content-item" style="height: 260px">
        <video
          muted="muted"
          preload="metadata"
          width="100%"
          height="100%"
          :src="voidUrl"
          controls="controls">
        </video>
      </div>
      <div class="video-content-item">
        <div>
          <p class="video-detail">
            {{voidObj.BRIEF_INTRO}}
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "videoDetail",
  props:['voidObj'],
  watch:{
    voidObj:{
      handler(oldVal,newVal) {
        this.getFilesSearch(oldVal.ID_)
      },
      deep:true,
      immediate:false
    }
  },
  data() {
    return {
      voidUrl:""
    }
  },
  mounted() {
    this.getVideo()
  },
  methods:{
    getVideo() {
      let record = {
        fields: {TYPE_: 'xc'}
      }
      this.$axios.post('/api/dftdstore/api/de/record/list?entityName=LOGIN_VIDEO_CONFIG',record).then((res) => {
        if (res.data.success) {
          res.data.rows.forEach((item,index) => {
            console.log(item,589);
            if (item.fields.PBLISH_HOME_PAGE === '1') {
              this.voidUrl = item.fields.URL_
              return false
            }
          })
        }
      })
    },
    moreProject() {
      window.open(`/calendarEventsInfo?id=${this.voidObj.ID_}&entityName=LOGIN_NEW_TRENDS`)
    },
    getmajorEventInfo() {
      window.open(`/calendarEventsInfo?id=${this.voidObj.ID_}&entityName=LOGIN_NEW_TRENDS`)
    },
    // 获取附件
    getFilesSearch(row) {
      // let host = window.location.host;
      this.$axios.post(`/api/fs/files/search?metaData.formId=${row}&metaData.fileType=voidUrl`).then(res => {
        if (res.status === 200) {
          res.data.forEach((item,index) => {
            item.name = item.filename
            item.url = `/api/fs/files/download/${item.id}`
          })
        }
      });
    },
  }
}
</script>

<style scoped>
.video-content {
  width: 35%;
  height: 100%;
  border-radius: 5px;
  font-size: 14px;
  box-sizing: border-box;
  border: 1px solid #eaeaea;
  padding: 0 15px 15px 15px;
  margin-right: 6px;
}
.video-content-item {
  width: 100%;
  /*height: 63%;*/
  box-sizing: border-box;
  overflow: hidden;
  /*display: flex;*/
  /*align-items: center;*/
}
.majorEvents-title {
  height: 64px;
  font-weight: 600;
  background-color: #fff;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.font-style {
  font-weight: 600;
  margin-bottom: 10px;
  position: relative;
  z-index: 9;
  background-color: #fff;
}
.video-title{
  font-weight: 600;
  margin-bottom: 10px;
  display: block;
  text-decoration: underline;
}
.video-title:hover {
  text-decoration: underline;
  cursor: pointer;
}
.video-frame-title {
  margin-top: 5px;
  color: #999999;
  font-size: 12px;
  display: flex;
  justify-content: space-between;
}
p {
  /*margin-top: 10px;*/
  text-indent: 2em;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 5;
  -webkit-box-orient: vertical;
  font-size: 14px;
  line-height: 25px;
}
video {
  background-color: black;
  overflow:hidden;
}
</style>



// WEBPACK FOOTER //
// src/components/modularMain/videoDetail.vue